import { useState } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { Button } from "../ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";
import { PUB, postJSON } from "./fq";

export default function CommunityForm() {
  const [f, setF] = useState({ name: "", email: "", phone: "", city: "", interest: "", consent_updates: false, website: "" });
  const [st, setSt] = useState({ s: "idle" });
  const set = (k, v) => setF({ ...f, [k]: v });
  const submit = async (e) => {
    e.preventDefault();
    setSt({ s: "loading" });
    try { await postJSON(`${PUB}/community`, f); setSt({ s: "done" }); }
    catch (err) { setSt({ s: "error", msg: err.message }); }
  };
  if (st.s === "done") return (
    <div className="fq-panel text-center py-10" data-testid="community-success">
      <CheckCircle2 className="w-10 h-10 mx-auto text-[#2F6B3A]" />
      <p className="mt-3 font-semibold">You're on the updates list.</p>
      <p className="text-sm opacity-80">We'll share community-expansion news only. You can ask us to stop at any time.</p>
    </div>
  );
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="community-form">
      <div className="grid sm:grid-cols-2 gap-4">
        {[["name", "Name *", "text"], ["email", "Email", "email"], ["phone", "Phone", "tel"], ["city", "City", "text"]].map(([k, l, t]) => (
          <div key={k} className="space-y-1.5"><Label className="text-sm font-semibold">{l}</Label><Input type={t} data-testid={`community-${k}`} value={f[k]} onChange={(e) => set(k, e.target.value)} required={k === "name"} /></div>
        ))}
      </div>
      <div className="space-y-1.5"><Label className="text-sm font-semibold">What would you like to hear about?</Label><Input data-testid="community-interest" value={f.interest} onChange={(e) => set("interest", e.target.value)} placeholder="e.g. new centres in my city" /></div>
      <input type="text" tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" value={f.website} onChange={(e) => set("website", e.target.value)} />
      <label className="flex items-start gap-3 text-sm cursor-pointer">
        <Checkbox data-testid="community-consent" checked={f.consent_updates} onCheckedChange={(v) => set("consent_updates", !!v)} className="mt-0.5" />
        <span>Send me Purnabramha community-expansion updates. I understand this is not an investment offer, share reservation or contribution request.</span>
      </label>
      {st.s === "error" && <div className="fq-callout danger" data-testid="community-error">{st.msg}</div>}
      <Button type="submit" className="fq-cta" disabled={st.s === "loading" || !f.consent_updates} data-testid="community-submit">{st.s === "loading" && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Get updates</Button>
    </form>
  );
}
